import { IEvaluationQueryModel } from 'src/app/shared/models/evaluation/evaluationQueryModel';

export function isSubmitted(row: IEvaluationQueryModel): boolean {
  return !!row && !!row.evaluationResponseDate && !!row.responses && row.responses.length > 0;
}

export function stripHtml(value: string): string {
  if (!value) return '';
  // Use a textarea (not a div) so embedded markup can't trigger DOM side effects.
  const withoutTags = value.replace(/<[^>]+>/g, '');
  const ta = document.createElement('textarea');
  ta.innerHTML = withoutTags;
  return ta.value.replace(/\s+/g, ' ').trim();
}

export function toCsvRow(cells: string[]): string {
  return cells.map(toCsvCell).join(',');
}

function toCsvCell(value: string): string {
  const v = value ?? '';
  const sanitizedValue = /^[=+\-@]/.test(v.trimStart()) ? `'${v}` : v;
  if (/[",\n\r]/.test(sanitizedValue)) {
    return `"${sanitizedValue.replace(/"/g, '""')}"`;
  }
  return sanitizedValue;
}

export function triggerCsvDownload(csv: string, filename: string): void {
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

export function safeFileNameFor(label: string, suffix: string): string {
  const base = (label?.trim() || 'evaluation').replace(/[^A-Za-z0-9-_]+/g, '_').replace(/_+/g, '_');
  return `${base}_${suffix}.csv`;
}
